import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {SettingsService} from '../../shared/services/settings.service';
import {ChecklistConfigModel, ChecklistItem} from '../../models/ChecklistModel';
import { FormGroup, Validators, FormControl, FormBuilder } from '@angular/forms';
import {ApplicationDetail} from "../../models/ApplicationDetail";

@Component({
  selector: 'app-application-checklist',
  templateUrl: './application-checklist.component.html',
  styleUrls: ['./application-checklist.component.css']
})
export class ApplicationChecklistComponent implements OnInit {

  @Input() showErrors: boolean;
  @Input() showChecklistItems: boolean;
  @Input() disabledButtons: boolean;
  @Input() checklists: ChecklistConfigModel[];
  @Input() applicationForm : FormGroup;
  @Input() appDetail:ApplicationDetail;
  
     
  public checklistItemLocal: Array <ChecklistItem> = [];
  constructor(private settingsService: SettingsService, private fb: FormBuilder) { }

  ngOnInit() {}


}
